module.exports = __webpack_public_path__ + "img/R-C.1b5fe40f.png";